import bussiness from '~/assets/icons/bussiness.svg';
import car from '~/assets/icons/car.svg';
import compass from '~/assets/icons/compass.svg';
import house from '~/assets/icons/home.svg';
import shirt from '~/assets/icons/tshirt.svg';

export enum AppAuctionTypes {
	Realty = 'realty',
	Vehicle = 'vehicle',
	Bussiness = 'bussiness',
	Clothes = 'clothes',
}

export enum AppAuctionFilter {
	Main = 'main',
	Realty = AppAuctionTypes.Realty,
	Vehicle = AppAuctionTypes.Vehicle,
	Bussiness = AppAuctionTypes.Bussiness,
	Clothes = AppAuctionTypes.Clothes,
}

export enum AppAuctionPages {
	Main = 'main',
	MyBids = 'myBids',
	Favorites = 'favorites',
}

export const appAuctionFilterButtons = {
	[AppAuctionFilter.Main]: {
		name: 'Главная',
		icon: compass,
	},
	[AppAuctionFilter.Realty]: {
		name: 'Недвижимость',
		icon: house,
	},
	[AppAuctionFilter.Vehicle]: {
		name: 'Транспорт',
		icon: car,
	},
	[AppAuctionFilter.Clothes]: {
		name: 'Одежда',
		icon: shirt,
	},
	[AppAuctionFilter.Bussiness]: {
		name: 'Разное',
		icon: bussiness,
	},
};
